import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  info() {
    return api.get(`/api/user/info`);
  },
};
